import React from "react";
import "./BusinessScopes.css";
import { Link } from "react-router-dom";

const BusinessScopes = () => {
  return (
    <div className="BusinessScopes-parent-div">
      <h1 className="BusinessScopes-heading">Business Scopes</h1>
      <h2 className="BusinessScopes-international">
        অল্প পুঁজিতে ইন্টারন্যাশনাল লাভজনক ব্যবসা
      </h2>

      <p className="BusinessScopes-p">
        নিচে যে কয়টি ব্যবসা উল্লেখ করা হয়েছে, সেগুলোর প্রত্যেকটি আমি নিজে
        বাংলাদেশ থেকে সাক্সেস্ফুলি ট্রাই করে দেখেছি যে এই ব্যবসা করা সম্ভব।
        কিন্তু আমি এই সবগুলো ধরে রাখিনি। শুধুমাত্র সফটওয়্যার এবং ট্রেইনিং নিয়ে
        আছি। সকল দিকে মনোযোগ দেয়া আমার পক্ষে সম্ভব হয় নি। সফটওয়্যারটাই একমাত্র
        ব্যবসা যেটার সাথে ফিল্ডের কোন যোগাযোগ নেই। মানে কোন প্রোডাক্ট কেনার
        ঝামেলা নেই, প্যাকেজিং করে শিপিং করার ভেজাল নেই। ম্যানুফ্যাকচার,
        সাপ্লাইয়ার, ট্র্যান্সপোর্ট, কাস্টমস, পোর্ট এগুলার সাথে ডিল করার ঝামেলা
        নেই। তবে আপনি যদি এইসব ডিল করতে পারেন, তবে আপনিও এগুলো নিয়ে ব্যবসা করে
        লাভবান হতে পারেন।{" "}
      </p>

      <p className="export-business-idea">Export Business Ideas : </p>
      <ul className="BusinessScope-ul">
        <li>Print, </li>
        <li>Apparel, </li>
        <li>Software,</li>
        <li>Seashells, </li>
        <li>Jute items</li>
        <li>Handicrafts, </li>
        <li>Home decor artificial plants,</li>
        <li>Custom tailored (shirts pants suits), </li>
      </ul>

      <div className="need-for-business-div">
        <p className="need-for-business-text">
          এবং সবচেয়ে আকর্ষণীয় বিষয় হলো এই সকল ব্যবসা করতে আপনার অনেক
          ইনভেস্টমেন্ট লাগবে না। যেগুলো প্রয়োজন হবে সেগুলো হলো -
        </p>
        <p>১) একটি ওয়েবসাইট</p>
        <p>২) ওয়েবসাইটে পেমেন্ট নেয়ার সিস্টেম </p>
        <p>
          {" "}
          ৩) প্রোডাক্ট প্যাকেজিং-এর জন্য ৫ - ১০ হাজার টাকা (যদি কোন প্রোডাক্ট
          শিপ করতে হয়){" "}
        </p>
        <p>
          {" "}
          ৪) যে পরিমাণ প্রোডাক্ট কিনবেন তার জন্য টাকা। অবশ্য, প্রোডাক্ট কেনার
          টাকা বেশীরভাগ সময় বায়ার আগেই পে করে দেয়।
        </p>
        <p> ৫) ধরে নিচ্ছি আপানার নিজের কম্পিউটার, ফোন - এগুলো আগে থেকেই আছে।</p>
        <p>
          {" "}
          ৬) সবচেয়ে ইম্পরট্যান্ট যে খরচটি আছে সেটি হল কন্সাল্টেন্সি ফি। এই
          কন্সাল্টেন্সি ফি দিতে অনেকেরই খুব কষ্ট হয়। কিন্তু এটাই সবথেকে জরুরী
          ইনভেস্টমেন্ট। কারণ আপনি অনেক টাকা-পয়সা, এনার্জি খরচ করবেন একটি ব্যবসায়
          লস খাওয়ার জন্য নিশ্চয়ই নয়। তো আপনি যে ব্যবসাটা শুরু করতে যাচ্ছেন, সেটি
          কি আপনি পূর্বে করেছেন? কোথায় কোথায় ঝড়-ঝাপ্টা আসবে আপনি কি জানেন? এই ৫
          - ১০ হাজার টাকা কন্সাল্টেন্সি ফী দিতে কার্পণ্য করে পুরো ব্যবসাটাই আপনি
          ঝুকির মধ্যে ফেলে দিচ্ছেন - পরে আবার হা-হুতাশ করছেন যে কিভাবে কি হয়ে
          গেলো! মনে রাখবেন, যারা কন্সাল্টেন্সি দেয়, তারা এই পথে হেঁটে, সবকিছু
          ফেইস করে এসেছে বলেই তারা আপনাকে দিকনির্দেশনা দিতে পারে। শুধু বই পরে
          কন্সাল্টেন্সি দেয়া হয় না। সুতরাং এই জায়গায় কার্পণ্য না করে এটাই সবার
          আগে করুন - কন্সাল্টেন্সি নেন - পুরো ব্যপারটি আগে বুঝে নিন, তারপর
          ফিল্ডে নামুন।
        </p>
        <p className="understand-business">
          [Understand Business licensing, Corresponding, Sourcing, Packing,
          Shipping, How to market products/services in an international
          marketplace (affiliate marketing / drop shipping- keeping agents in
          line), How to accept payments from your customers or clients, Handling
          Obstacles and challenges]{" "}
          <small className="বিস্তারিত">
            এই সকল ব্যবসার বিস্তারিত জানতে ভিজিট করুন -
          </small>
          <Link
            className="understand-business-link"
            to="https://bd.teacherjackonline.com/"
            target="blank"
          >
            {" "}
            bd.teacherjackonline.com.
          </Link>{" "}
          * Consultancy on Online Business ideas & scopes - How to know the
          entire business process on each of this businesses.
        </p>
      </div>
    </div>
  );
};

export default BusinessScopes;
